export enum GiftDisplayTypeEnum {
  TEXT = 'text',
  BARCODE = 'barcode',
  QR_CODE = 'qr-code',
  URL = 'url',
  BUTTON = 'button',
}
